import { FC } from 'react';
import { Divider, HStack } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';

import locales from './locales';

interface LinkToInvoiceButtonProps {
  onClick: () => void;
}

const LinkToInvoiceButton: FC<LinkToInvoiceButtonProps> = ({ onClick }) => (
  <>
    <SunshineCard alignItems="center" onClick={onClick}>
      <SunshineCard.Slot name="aside">
        <SquircleIcon name="invoice" />
      </SunshineCard.Slot>

      <SunshineCard.Content>
        <SunshineCard.Title>{locales.title}</SunshineCard.Title>
      </SunshineCard.Content>

      <SunshineCard.Slot name="action">
        <SunshineCard.SunshineIcon name="chevron-right" />
      </SunshineCard.Slot>
    </SunshineCard>

    <HStack gap="space-24" paddingY="space-12">
      <Divider />
      <Text>{locales.or}</Text>
      <Divider />
    </HStack>
  </>
);

export default LinkToInvoiceButton;
